module.exports = __webpack_public_path__ + "img/1f919-1f3fb.a4c0518.svg";